import { SmsService } from './../../services/SmsService';
import { LoginserviceService } from "src/app/services/loginservice.service";
import { Component, OnInit } from "@angular/core";
import { AuthService } from '../../services/auth.service';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { AppSettings, Settings } from "src/app/app.settings";
import {
  SocialAuthService,
  FacebookLoginProvider,
  SocialUser,
  GoogleLoginProvider,
} from "angularx-social-login";
import { Socialusers } from "../Socialuser";
import { ToastrService } from 'ngx-toastr';
import { HostService } from 'src/app/services/host.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  public loginForm!: UntypedFormGroup;
  public hide = true;
  suUser: any;
  public bgImage: any;
  public settings: Settings;
  public data: any;
  public message: string | undefined;
  user: SocialUser = new SocialUser();
  isSignedin!: boolean;
  socialusers = new Socialusers();
  email: any;
  password: any;
  userDetails: any;
  constructor(
    public fb: UntypedFormBuilder,
    public router: Router,
    public phone: SmsService,
    private sanitizer: DomSanitizer,
    public appSettings: AppSettings,
    private toastr: ToastrService,
    public loginService: LoginserviceService,
    private socialAuthService: SocialAuthService,
    public OAuth: SocialAuthService,
    private auth: AuthService,
    public hostService:HostService,
    public snackBar: MatSnackBar,
  ) {
    this.auth.removeSessionAndLocalStorage();
    //https://www.youtube.com/watch?v=GZOV93NoXSI
  }

  ngOnInit(): void {

    this.auth.removeSessionAndLocalStorage();
    this.bgImage = this.sanitizer.bypassSecurityTrustStyle("url("+this.hostService.getHttpsImage()+"images/others/login.png");
    this.loginForm = this.fb.group({
     email: [null,Validators.compose([Validators.required,Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})|\+237|\+33\d{9}$/),]),],

      password: [
        null,
        Validators.compose([Validators.required, Validators.minLength(6)]),
      ],
      rememberMe: false,
    });
    google_id: "";
    this.socialAuthService.authState.subscribe((user) => {
      this.user = user;
      this.isSignedin = user != null;
    });

    //verifier si un profil existe dans la sessions
    const storageAuth = localStorage.getItem("user");
    if (storageAuth) {
      this.userDetails = JSON.parse(storageAuth);
     
      // this.router.navigateByUrl("/");
      // console.log(this.userDetails, 'version test');
    }
  }

  public onLoginFormSubmit(): void {
        const storageAuth = localStorage.getItem("user");
        
        if (storageAuth) {
          this.userDetails = JSON.parse(storageAuth);
          if (this.userDetails.roleApp) {
            this.router.navigateByUrl("/");
          }
          else{
            this.snackBar.open("Vous devez vous connecter afin de pouvoir changer le type de compte", "Fermer", {
              duration: 6000,
              verticalPosition: 'top',
              panelClass: ['snackbar-danger']
            });
            this.router.navigateByUrl("/switch");
          }
        }
    this.data = this.loginForm.value;
    this.email = this.data.email;
    this.password = this.data.password;
   
    //verified si c'est un phone ou email
    if (Number.parseFloat(this.email)) {
      // un phone
      this.auth.loginPhone(this.email, this.password);

    } else {
      // un email
      this.auth.login(this.email, this.password);
    }
  }
  resetpassword() {
    this.router.navigateByUrl("/reset");
  }
}
